var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "BaseModal",
    _vm._g(
      {
        attrs: {
          bem: _vm.bemBlock,
          "is-open": true,
          "modal-modifier": "bottom",
          "show-backdrop": true
        }
      },
      _vm.$listeners
    ),
    [
      _vm.currentItem === _vm.items.LOADING
        ? _c("BaseSpinner", { class: _vm.bemElement("loading") })
        : _vm._e(),
      _vm._v(" "),
      _vm.currentItem === _vm.items.SIZE_SELECTION
        ? _c(
            "div",
            { class: _vm.bemElement("selector") },
            [
              _c("span", { class: _vm.bemElement("title") }, [
                _vm._v(_vm._s(_vm.$msg("button.sizeselect", "product")))
              ]),
              _vm._v(" "),
              _c(
                "TheProductDetailsSizeSelector",
                _vm._g(
                  {
                    class: [_vm.bemElement("sizes"), "u-scroll-disabled"],
                    attrs: {
                      prefix: "modalSizeSelector",
                      "data-context": _vm.context,
                      product: _vm.product
                    }
                  },
                  _vm.$listeners
                )
              )
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.currentItem === _vm.items.ADDED_TO_CART
        ? _c(
            "div",
            { class: _vm.bemElement("added-msg") },
            [
              _c(
                "BaseProductTileImage",
                _vm._g(
                  {
                    class: _vm.bemElement("image"),
                    attrs: {
                      context: _vm.context,
                      "force-main-image-to-load": true,
                      "has-carousel": false,
                      product: _vm.product,
                      url: ""
                    }
                  },
                  _vm.$listeners
                )
              ),
              _vm._v(" "),
              _c("div", { class: _vm.bemElement("text") }, [
                _vm._v("\n      " + _vm._s(_vm.addedMessage) + "\n      "),
                _c(
                  "a",
                  {
                    class: ["link", "link--arrow", _vm.bemElement("link")],
                    attrs: { href: _vm.cartShowUrl }
                  },
                  [
                    _vm._v(
                      "\n        " +
                        _vm._s(_vm.$msg("button.productcard", "product")) +
                        "\n      "
                    )
                  ]
                )
              ])
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.currentItem === _vm.items.STOCK_ALERT
        ? _c(
            "TheProductDetailsStockAlert",
            _vm._g(
              {
                class: _vm.bemElement("stock-alert"),
                attrs: {
                  product: _vm.product,
                  "stock-alert-visible": true,
                  "stock-alert-size": _vm.selectedSize
                }
              },
              _vm.$listeners
            )
          )
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }